<template>
  <v-menu v-model="menuOpen" close-on-click offset-x bottom right transition="slide-x-transition">
    <template v-slot:activator="{ on, attrs }">
      <div class="card-action-box card-action-box--more" v-bind="attrs" v-on="on" role="button" aria-label="Mais opções">
        <v-icon>mdi-dots-horizontal</v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item @click="closeMenu">
        <v-list-item-title class="d-flex align-center">
          <ModalEnviarColaboracaoOuNoticiaParaPasta
            :id_colaboracao="item.id_colaboracao"
            :cod_producao="item.cod_producao"
            @open="closeMenu"
          />
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="closeMenu">
        <v-list-item-title class="d-flex align-center">
          <DuplicarColaboracaoButton
            :item="item"
            :getColaboracoesAprovadas="getColaboracoesAprovadas"
            :page="page"
            :flg_exibida="flg_exibida"
            :flg_favorita="flg_favorita"
            :cod_pasta="cod_pasta"
          />
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ModalEnviarColaboracaoOuNoticiaParaPasta from "@/components/Modal/Pastas/ModalEnviarColaboracaoOuNoticiaParaPasta.vue";
import DuplicarColaboracaoButton from "./DuplicarColaboracaoButton.vue";

export default {
  props: {
    item: Object,
    getColaboracoesAprovadas: Function,
    page: Number,
    flg_exibida: Boolean,
    flg_favorita: Boolean,
    cod_pasta: Number
  },
  components: {
    ModalEnviarColaboracaoOuNoticiaParaPasta,
    DuplicarColaboracaoButton
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
  },
};
</script>
